<template><div><h1 id="warenrucknahme-aus-auftrag" tabindex="-1"><a class="header-anchor" href="#warenrucknahme-aus-auftrag"><span>Warenrücknahme aus Auftrag</span></a></h1>
<p>Warenrücknahme aus Auftrag — Erfassen von Retouren</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dieses Programm ermöglicht die Rücknahme von Artikeln. Durch die Eingabe einer Personen-ID, einer Artikelnummer und der zurückzunehmenden Menge wird ein Auftrag gesucht. Die retournierte Ware wird aber <em>nicht</em> in den Auftragspositionen zurückgenommen. D.h. dass eine Retoure, die mit diesem Programm erfasst wird, im Auftrag nicht als zurückgenommen ersichtlich ist. Wird kein Auftrag gefunden, der zum Auftraggeber gehört und den zurückzunehmenden Artikel enthält, so eröffnet das Programm einen separaten Retourenauftrag. Erfassen und Einbuchen der erfassten Retouren sind im Programm getrennte Schritte (siehe Funktionen).</p>
<p>Pfad: <code v-pre>Verkauf → Verarbeitungsläufe → Warenrücknahmen aus Auftrag</code></p>
<h2 id="datenfelder-anzeige-modus" tabindex="-1"><a class="header-anchor" href="#datenfelder-anzeige-modus"><span>Datenfelder (Anzeige-Modus)</span></a></h2>
<dl>
<dt>Nr.</dt>
<dd>Laufnummer der erfassten Retourpositionen; wird vom System automatisch vergeben</dd>
<dt>Adressnummer</dt>
<dd>Personen-ID</dd>
<dt>Artikelnummer</dt>
<dd>Artikelnummer, der zurückgenommen werden soll, inkl. Angabe der Mediennummer</dd>
<dt>Einzelpreis</dt>
<dd>Stückpreis aus der Auftragsposition (wird nur angezeigt, wenn ein Auftrag gefunden wurde; editierbar wenn kein Auftrag gefunden wurde oder der Benutzer &quot;neuen Auftrag bilden&quot; gewählt hat)</dd>
<dt>Rabatt %</dt>
<dd>im Auftrag gewährter Rabatt in Prozent (Anzeige; editierbar analog EinzelPr)</dd>
<dt>Menge</dt>
<dd>Menge, die zurückgenommen wird</dd>
<dt>Gesamtwert</dt>
<dd>Auftragswert, der dem Kunden gutgeschrieben wird</dd>
<dt>Auftrag</dt>
<dd>Auftragsnummer, zu der eine Warenrücknahme erfolgt. ? = neuer Auftrag soll gebildet werden</dd>
<dt>Auftragsart</dt>
<dd>Auftragsart, die (z.B. für die Kontierung) verwendet wird</dd>
<dt>Lager</dt>
<dd>Lagerort-Nummer, an welche die Ware zurückgebucht werden soll (Standardmässig wird die Lagerortnummer aus dem Auftrag vorgeschlagen)</dd>
<dt>Faktura</dt>
<dd>Fakturanummer, zu der eine Warenrücknahme erfolgt</dd>
<dt>verkaufbar?</dt>
<dd>Verkaufbar? ja = Ware wird in den verkaufbaren Bestand zurückgebucht; nein = Ware wird in eine Retourpartie eingebucht</dd>
</dl>
<h2 id="datenfelder-edit-modus" tabindex="-1"><a class="header-anchor" href="#datenfelder-edit-modus"><span>Datenfelder (Edit-Modus)</span></a></h2>
<dl>
<dt>Ordnungsnr.</dt>
<dd>Laufnummer der erfassten Retourpositionen; wird vom System automatisch vergeben</dd>
<dt>Status</dt>
<dd>Status der erfassten Rücknahme (siehe Funktionen):
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>erfasst</td>
</tr>
<tr>
<td>3</td>
<td>Warenrücknahme wurde durchgeführt</td>
</tr>
<tr>
<td>X</td>
<td>erledigt, Protokoll wurde gedruckt</td>
</tr>
</tbody>
</table>
</dd>
<dt>Person</dt>
<dd>Personen-ID</dd>
<dt>Artikel</dt>
<dd>Artikelnummer, der zurückgenommen werden soll, inkl. Angabe der Mediennummer</dd>
<dt>ohne Label</dt>
<dd>Artikelbezeichnung</dd>
<dt>Menge</dt>
<dd>Menge, die zurückgenommen wird</dd>
<dt>Einzelpreis</dt>
<dd>Stückpreis aus der Auftragsposition (wird nur angezeigt, wenn ein Auftrag gefunden wurde; editierbar wenn kein Auftrag gefunden wurde oder der Benutzer &quot;neuen Auftrag bilden&quot; gewählt hat)</dd>
<dt>Rabatt %</dt>
<dd>im Auftrag gewährter Rabatt in Prozent (Anzeige; editierbar analog EinzelPr)</dd>
<dt>Gesamtwert</dt>
<dd>Auftragswert, der dem Kunden gutgeschrieben wird</dd>
<dt>MWST</dt>
<dd>Mehrwertsteuersatz des Artikels</dd>
<dt>Verkaufbar</dt>
<dd>Verkaufbar? ja = Ware wird in den verkaufbaren Bestand zurückgebucht; nein = Ware wird in eine Retourpartie eingebucht</dd>
<dt>Lager</dt>
<dd>Lagerort-Nummer, an welche die Ware zurückgebucht werden soll (Standardmässig wird die Lagerortnummer aus dem Auftrag vorgeschlagen)</dd>
<dt>Auftrag</dt>
<dd>Auftragsnummer, zu der eine Warenrücknahme erfolgt. ? = neuer Auftrag soll gebildet werden</dd>
<dt>Auftragsart</dt>
<dd>Auftragsart, die (z.B. für die Kontierung) verwendet wird</dd>
<dt>Fakturanummer</dt>
<dd>Fakturanummer, zu der eine Warenrücknahme erfolgt</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="warenrucknahme-durchfuhren" tabindex="-1"><a class="header-anchor" href="#warenrucknahme-durchfuhren"><span>Warenrücknahme durchführen</span></a></h3>
<p>Das System meldet die erfolgreich durchgeführte Rücknahme der Ware. Anschliessend muss das Protokoll der durchgeführten Schritte ausgedruckt werden.</p>
<h3 id="protokoll-drucken" tabindex="-1"><a class="header-anchor" href="#protokoll-drucken"><span>Protokoll drucken</span></a></h3>
<p>Im Protokoll wird festgehalten, welche Artikel, Artikelmengen und Umsätze zurückgenommen und in den verschiedenen Buchungen neutralisiert wurden.</p>
<h3 id="ausgedrucktes-protokoll-loschen" tabindex="-1"><a class="header-anchor" href="#ausgedrucktes-protokoll-loschen"><span>ausgedrucktes Protokoll löschen</span></a></h3>
<p>Bevor eine neue Warenrücknahme durchgeführt werden kann, muss das alte Protokoll gelöscht werden.</p>
<p>Bereits erfasste - aber im letzten Lauf nicht verarbeitete - Warenrücknahmen werden beim Löschen nicht berücksichtigt. Nach dem Löschen kann erneut Warenrücknahme gewählt werden.</p>
<p>Die gelöschten Protokolle werden in das Fenster &quot;Alte Warenrücknahme aus Auftrag (Protokoll)&quot; verschoben, so dass die Information, wann welche Artikel gelöscht wurden, erhalten bleibt.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung">Auftragsverwaltung</RouteLink></p>
</div></template>


